<template>
  <div class="batch_order">
    <div class="batch_order_title">订单盈亏统计表</div>
    <div class="batch_tab">
      <div class="screen_input">
        <div id="range_date">
          下单时间
          <el-date-picker
            class="screen range_date"
            v-model="timeSlot"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
        <div>
          订单编号
          <el-input
            class="screen"
            v-model="params.orderNo"
            placeholder="请输入订单编号"
          ></el-input>
        </div>
        <div>
          物流单号
          <el-input
            class="screen"
            v-model="params.logisticsNo"
            placeholder="请输入物流单号"
          ></el-input>
        </div>
        <template v-if="toggleSearchStatus">
          <div>
            是否核销
            <el-select
              class="screen"
              v-model="params.isVerify"
              placeholder="请选择"
              @change="checkSelect"
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </div>
        </template>
      </div>
      <div class="order_btns">
        <el-button class="order_search" @click="loadData(1)">搜索</el-button>
        <el-button class="order_clear" @click="orderClear()">重置</el-button>
        <el-button
          class="order_clear"
          v-loading="exportLoading"
          @click="exportExcel"
          >导出数据</el-button
        >
        <a
          @click="toggleSearchStatus = !toggleSearchStatus"
          style="margin-left: 8px"
        >
          {{ toggleSearchStatus ? "收起" : "展开" }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
        </a>
      </div>
    </div>
    <div class="profit_loss" v-if="countShow">
      <div>
        应收总计<span>¥{{ countData.orderReceivable || 0 }}</span>
      </div>
      <div>
        师傅成本总计<span>¥{{ countData.workerCost || 0 }}</span>
      </div>
      <div>
        盈亏总计<span>¥{{ countData.profitAndLoss || 0 }}</span>
      </div>
    </div>
    <div v-if="orderItems.records.length">
      <el-table
        class="table_mian"
        :data="orderItems.records"
        style="width: 100%"
        v-loading="loadLing"
        ref="multipleTable"
        @select="dealWith"
      >
        <el-table-column fixed type="selection" width="40"> </el-table-column>
        <el-table-column
          fixed
          prop="verifyTime"
          label="核销"
          width="140"
          header-cell-class-name="head"
        >
          <template slot-scope="scope">
            {{ scope.row.verifyTime || "/" }}
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单编号" width="145">
          <template slot-scope="scope">
            <a style="color: #3455d3" @click="openOrderInfo(scope.row)">
              {{ scope.row.orderNo || "/" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="goodsTypeName" label="商品类目" width="100">
        </el-table-column>

        <el-table-column prop="serviceTypeName" label="服务类型" width="100">
        </el-table-column>
        <el-table-column
          prop="logisticsNo"
          label="物流单号"
          show-overflow-tooltip
          width="130"
        >
          <template slot-scope="scope">
            {{ scope.row.logisticsNo || "/" }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="订单状态" width="80">
        </el-table-column>
        <el-table-column prop="orderProfitAndLoss" label="订单盈亏" width="100">
          <template slot-scope="scope">
            <div class="red">¥{{ scope.row.orderProfitAndLoss || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderReceivable" label="订单应收" width="100">
          <template slot-scope="scope">
            <div class="editable">
              ¥{{ scope.row.orderReceivable || 0 }}
              <svg
                class="icon iconbianji"
                @click="
                  onEdit(
                    { type: '订单应收', value: 'orderReceivable' },
                    scope.row
                  )
                "
                aria-hidden="true"
              >
                <use xlink:href="#iconbianji"></use>
              </svg>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="otherReceivable" label="其他应收" width="100">
          <template slot-scope="scope">
            <div class="editable">
              ¥{{ scope.row.otherReceivable || 0 }}
              <svg
                class="icon iconbianji"
                @click="
                  onEdit(
                    { type: '其他应收', value: 'otherReceivable' },
                    scope.row
                  )
                "
                aria-hidden="true"
              >
                <use xlink:href="#iconbianji"></use>
              </svg>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalReceivable" label="应收总计" width="100">
          <template slot-scope="scope">
            <div class="red">¥{{ scope.row.totalReceivable || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderWorkerCost"
          label="下单师傅成本"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="orderMarkup" label="订单加价" width="100">
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" width="140">
        </el-table-column>
        <el-table-column label="备注" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="editable">
              {{ scope.row.remark }}
              <svg
                class="icon iconbianji"
                @click="onEdit({ type: '备注', value: 'remark' }, scope.row)"
                aria-hidden="true"
              >
                <use xlink:href="#iconbianji"></use>
              </svg>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="null-info" v-if="!orderItems.records.length">
      <img src="@/assets/img/pic_none.png" alt />
      暂无信息...
    </div>
    <el-pagination
      v-show="orderItems.total > 10"
      class="fenye"
      background
      layout="prev, pager, next"
      :total="Number(orderItems.total)"
      :page-size="10"
      @current-change="pageSize"
    ></el-pagination>
    <editModal ref="editModal" @ok="loadData"></editModal>
    <orderInfo-modal ref="orderInfoModal"></orderInfo-modal>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { postAction, getAction } from "@/api/manage";
import editModal from "./modules/editModal";
import orderInfoModal from "@/components/user/modules/orderInfoModal";

export default {
  components: {
    editModal,
    orderInfoModal,
  },
  data() {
    return {
      loadLing: false,
      toggleSearchStatus: false,
      url: {
        list: "/order/api/order/revenue/list",
        export: "/order/api/order/revenue/export",
        dealWith: "/order/api/order/revenue/handle",
        count: "/order/api/order/revenue/count",
      },
      params: {},
      orderItems: {
        total: 0,
        records: [],
      },
      pageNo: 1,
      timeSlot: ["", ""],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      allTbable: [],
      multipleSelection: [],
      firstLoad: false,
      exportLoading: false,
      countData: {},
      countShow: false,
    };
  },
  // computed:{
  //   countShow(){
  //     let params=JSON.parse(JSON.stringify(this.params))
  //     delete params.pageIndex
  //     delete params.pageSize
  //     if(this.timeSlot[0]||Object.values(params).length) return true
  //     else return false
  //   }
  // },
  created() {
    this.loadData();
  },
  methods: {
    // 跳转订单详情
    openOrderInfo(row) {
      this.$refs.orderInfoModal.open({ id: row.orderId });
    },
    // 获取盈亏统计
    async getCount() {
      let _this = this;
      if (_this.timeSlot[0]) _this.params.createStartTime = _this.timeSlot[0];

      if (_this.timeSlot[1]) {
        _this.params.createEndTime =
          _this.timeSlot[1].split(" ")[0] + " 23:59:59";
      }
      let params = Object.assign(this.params);
      const { data } = await getAction(this.url.count, params);
      console.log(data);
      this.countData = data.data;
    },
    onEdit(type, row) {
      this.$refs.editModal.init(type, row);
    },
    // 处理
    dealWith(selection, row = {}) {
      // this.$refs.multipleTable.toggleRowSelection(row, row.isVerify);
      // let dealWithText = "";
      // if (row.isVerify) dealWithText = "当前订单盈亏您确认取消吗?";
      // else dealWithText = "当前订单盈亏您确认已完成吗?";
      // this.$confirm(dealWithText, "处理确认")
      //   .then(() => {
      getAction(this.url.dealWith, { revenueId: row.id })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success("处理成功");
            this.loadData();
            // this.$refs.multipleTable.toggleRowSelection(row, !row.isVerify);
          }
        })
        .finally(() => {
          this.loading = false;
        });
      // })
      // .catch(() => {
      //   console.log(row.isVerify);
      //   this.$refs.multipleTable.toggleRowSelection(row, row.isVerify);
      // });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    pageSize(val) {
      this.pageNo = val;
      this.loadData();
    },
    // 导出excel
    exportExcel() {
      let _this = this;
      this.exportLoading = true;
      if (_this.timeSlot[0]) _this.params.createStartTime = _this.timeSlot[0];

      if (_this.timeSlot[1]) {
        _this.params.createEndTime =
          _this.timeSlot[1].split(" ")[0] + " 23:59:59";
      }
      let params = Object.assign(this.params, {
        pageIndex: 1,
        pageSize: 1,
      });
      postAction(this.url.export, params)
        .then((res) => {
          if (res.data.code == 0) {
            this.allTbable = res.data.data;
            this.allTbable.map((i) => {
              // i["goodsName"] = i.orderItems ? i.orderItems[0].name : "";
              // i["goodsCount"] = i.orderItems ? i.orderItems[0].count : "";
              i["verifyText"] = i.isVerify ? "已核销" : "未核销";
              i["orderFollowText"] = i.orderFollows
                .map((j) => j.createTime+','+j.content)
                .join();
              return i;
            });
          }
        })
        .finally(() => {
          if (this.allTbable.length) {
            import("@/vendor/Export2Excel").then((excel) => {
              const tHeader = [
                "下单时间",
                "订单编号",
                "商品类目",
                "服务类型",
                "物流单号",

                "客户姓名",
                "客户电话",
                "客户地址",
                "品名",
                "体积",
                "包装件数",

                "订单状态",
                "订单盈亏",
                "订单应收",
                "其他应收",
                "应收总计",
                "下单师傅成本",
                "订单加价",
                "盈亏备注",

                "核销状态",

                "核销时间",
                "验收时间",
                "订单跟进",
              ];
              const filterVal = [
                "createTime",
                "orderNo",
                "goodsTypeName",
                "serviceTypeName",
                "logisticsNo",

                "customerName",
                "customerPhone",
                "address",
                "goodsName",
                "totalVolume",
                "goodsCount",

                "statusName",
                "orderProfitAndLoss",
                "orderReceivable",
                "otherReceivable",
                "totalReceivable",
                "orderWorkerCost",
                "orderMarkup",
                "remark",

                "verifyText",

                "verifyTime",
                "acceptanceTime",
                "orderFollowText",
              ];
              const data = this.formatJson(filterVal, this.allTbable);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "订单盈亏统计表",
              });
            });
            this.exportLoading = false;
          }
        });
    },
    // 把要导出的数据生成 json
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "date") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    loadData(type) {
      let _this = this;
      this.loadLing = true;
      if (_this.timeSlot[0]) _this.params.createStartTime = _this.timeSlot[0];

      if (_this.timeSlot[1]) {
        _this.params.createEndTime =
          _this.timeSlot[1].split(" ")[0] + " 23:59:59";
      }
      let params = Object.assign(this.params, {
        pageIndex: this.pageNo,
        pageSize: 10,
      });
      this.getCount();
      postAction(this.url.list, params)
        .then((res) => {
          if (res.data.code == 0) {
            this.orderItems = res.data.data;
            if (type) this.countShow = true;
          }
        })
        .finally(() => {
          this.orderItems.records.map((i) => {
            if (i.isVerify) this.$refs.multipleTable.toggleRowSelection(i);
          });
          this.loadLing = false;
        });
    },
    orderClear() {
      this.params = {};
      this.timeSlot = ["", ""];
      this.loadData();
    },
  },
};
</script>
<style lang='scss'>
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3455d3;
  border-color: #3455d3;
}
</style>
<style lang='scss' scoped>
.batch_order {
  background: #ffffff;
  padding: 0 0 24px 0;
  .batch_order_title {
    color: #5e6066;
    height: 66px;
    background: #ffffff;
    padding: 24px 20px 25px 20px;
    border-bottom: 1px solid #dfe4eb;
    font-size: 18px;
  }
  /deep/.order_btns {
    padding: 0 20px 20px;
    a {
      color: #3455d3;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }
  .screen_input {
    // padding: 0 20px 0 20px;
    padding: 20px 20px 0;
    // height: 170px;
    & > div {
      margin-bottom: 16px;
    }
    .screen {
      // width: 210px;
      width: 230px;
      height: 34px;
      &/deep/input {
        height: 34px;
        // padding: 0 !important;
        line-height: 0;
      }
    }
  }
}
/deep/ .table_mian {
  th {
    .el-checkbox {
      display: none;
    }
  }
  .editable {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    height: 100%;
    .iconbianji {
      position: absolute;
      color: #b4b7bc;
      top: 4px;
      right: 12px;
      cursor: pointer;
      &:hover {
        color: #a7a8ab;
      }
    }
  }
  .red {
    color: #f75658;
  }
  .el-checkbox {
    margin-top: 0;
  }
  th {
    background: #f9fafa;
    font-size: 12px;
    text-align: center;
    padding: 0;
    &:nth-child(2) .cell {
      justify-content: flex-start;
    }
  }
  .el-table-column--selection {
    .cell {
      padding-left: 24px !important;
      padding-right: 0 !important;
    }
  }
  th > .cell {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5e6066;
    font-weight: normal;
  }
  td div {
    padding: 0 10px;
  }
  .el-table__cell {
    padding: 0;
  }
  td,
  th {
    padding: 0;
  }
  .cell {
    height: 52px;
    line-height: 52px;
    font-size: 12px;
    color: #2f3133;
    text-align: center;
  }
  .el-table__fixed {
    height: calc(100% - 8px) !important;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #caccd3;
  }
  ::-webkit-scrollbar-corner {
    // background: #f6f6f6;
    background: transparent;
  }
}
.order_search {
  // width: 124px;
  width: 106px;
  height: 34px;
  background: #3455d3;
  border-color: #3455d3;
  border-radius: 2px;
  font-size: 14px;
  line-height: 5px;
  color: #fff;
  &:hover {
    background: #2c4abb;
    border-color: #2c4abb;
  }
}
.order_clear {
  width: 106px;
  height: 34px;
  border-radius: 2px;
  border: 1px solid rgba(180, 183, 188, 1);
  color: #5e6066;
  font-size: 14px;
  line-height: 5px;
  /deep/.circular {
    width: 30px;
    height: 30px;
    margin-top: 6px;
  }
  &:focus,
  &:hover {
    color: #3455d3;
    border-color: #3455d3;
    background: #fff;
  }
}

.profit_loss {
  padding: 0 20px;
  height: 38px;
  display: flex;
  align-items: center;
  background: #eef0f3;

  & > div {
    color: #5e6066;
    font-size: 12px;
    margin-left: 18px;
    &:first-child {
      margin-left: 0;
    }
    span {
      color: #f75658;
      font-weight: bold;
      margin-left: 8px;
    }
  }
}
.null-info {
  background: #fff;
  padding: 30px 261px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #b4b7bc;
  margin-top: 15px;

  img {
    width: 375px;
    height: 94px;
    margin-bottom: 8px;
  }
}
</style>
